<div id="app">
    <v-app id="appRt">
        <v-content>
            <nav aria-label="breadcrumb" v-if="breadcrumbList.length !== 0 && showBreadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="/applications/dashboard"> {{$t('dashboard')}}</a></li>
                    <li class="breadcrumb-item" :class="{'active': !breadcrumb.link}" v-for="(breadcrumb, idx) in breadcrumbList" :key="idx">
                        <a @click="routeTo(idx)" v-if="breadcrumb.link">{{$t(breadcrumb.name)}}</a>
                        <span v-if="!breadcrumb.link">{{$t(breadcrumb.name)}}</span>
                    </li>
                </ol>
            </nav>
            <router-view/>
        </v-content>
    </v-app>
</div>